import isNote from 'app/forms/validations/isNote';

export const NOTICES_FORM_NAME = 'productionControlDetail-notices';

export const FIELDS = {
	noticeTextContent: 'noticeTextContent',
	documentState: 'documentState',
	centralConsent: 'centralConsent',
	addedNoticeFullName: 'addedNoticeFullName',
	addedNoticeDateCreated: 'addedNoticeDateCreated',
	addedNoticeDocumentState: 'addedNoticeDocumentState',
	addedNoticeCentralConsent: 'addedNoticeCentralConsent',
	addedNoticeTextContent: 'addedNoticeTextContent',
};

export default () => ({
	[FIELDS.noticeTextContent]: {
		deepPath: [FIELDS.noticeTextContent],
		validations: [isNote()],
	},
	[FIELDS.documentState]: {
		deepPath: [FIELDS.documentState],
		validations: [],
	},
	[FIELDS.centralConsent]: {
		deepPath: [FIELDS.centralConsent],
		validations: [],
	},
	[FIELDS.addedNoticeFullName]: {
		deepPath: [FIELDS.addedNoticeFullName],
		validations: [],
	},
	[FIELDS.addedNoticeDateCreated]: {
		deepPath: [FIELDS.addedNoticeDateCreated],
		validations: [],
	},
	[FIELDS.addedNoticeDocumentState]: {
		deepPath: [FIELDS.addedNoticeDocumentState],
		validations: [],
	},
	[FIELDS.addedNoticeCentralConsent]: {
		deepPath: [FIELDS.addedNoticeCentralConsent],
		validations: [],
	},
	[FIELDS.addedNoticeTextContent]: {
		deepPath: [FIELDS.addedNoticeTextContent],
		validations: [],
	},
});
